import { render, staticRenderFns } from "./IntegrationsSettingsIcon.vue?vue&type=template&id=16b838a6&scoped=true"
import script from "./IntegrationsSettingsIcon.vue?vue&type=script&lang=js"
export * from "./IntegrationsSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b838a6",
  null
  
)

export default component.exports